import React from "react";
import Divider from "@material-ui/core/Divider";
import { Box, Popover } from "@material-ui/core";
import styles from "./ShiftMasterForm.module.css";
import { Button } from "../../atomicComponents";
import clsx from "clsx";
import { useState } from "react";
import { TimePicker } from "@material-ui/pickers";
import moment from "moment";
import CustomSelect from "../FormComponents/CustomSelect";
import CustomDatePicker from "../CustomDatePicker/CustomDatePicker";
import { DATE_FORMAT } from "../../constants";

const ShiftMasterForm = ({ closeFormPopup, addMasterShift }) => {
  const [startTime, setStartTime] = useState(null);
  const [endtime, setEndTime] = useState(null);
  const [activeFrom, setActiveFrom] = useState(moment().format(DATE_FORMAT.ISO));
  const [activeUntil, setActiveUntil] = useState(moment().format(DATE_FORMAT.ISO));
  const shiftNames = [
    { value: "A", label: "A" },
    { value: "B", label: "B" },
    { value: "C", label: "C" },
    { value: "G", label: "G" },
  ];
  const [shift, setShift] = useState(shiftNames[0]);

  const selectShift = (value) => {
    setShift(value);
  };

  const formSubmit = (event) => {
    if (
      shift &&
      startTime &&
      endtime &&
      activeFrom &&
      activeUntil &&
      moment(activeUntil) >= moment(activeFrom)
    ) {
      const formData = {
        shiftName: shift.value,
        startTime: moment
          .utc(startTime)
          .utcOffset("+05:30")
          .format("HH:mm:ss.SZ"),
        endTime: moment.utc(endtime).utcOffset("+05:30").format("HH:mm:ss.SZ"),
        activeFromDate: moment(activeFrom).format("YYYY-MM-DD"),
        activeToDate: moment(activeUntil).format("YYYY-MM-DD"),
      };
      addMasterShift(formData);
    }
  };
  return (
    <>
      <Popover
        open={true}
        anchorOrigin={{
          vertical: "center",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "center",
          horizontal: "center",
        }}
        className={styles.popoverBck}
      >
        <form className={styles.formBox}>
          <div className={styles.formTitleNew}>
            <span className={styles.formTitle}>Shift Master</span>
            <div className={styles.formlLineDiv} />
          </div>
          <Box
            bgcolor="#dadada3d"
            paddingTop="14px"
            paddingBottom="14px"
            borderRadius="6px"
          >
            <span className={styles.titlespan}>Shift</span>
            <span
              style={{ display: "inline", marginLeft: "18%" }}
              className={styles.formSubTitle}
            >
              <CustomSelect
                name="Shift"
                isMandatory
                options={shiftNames}
                className={clsx(styles.dropDownSelect, styles.sel1)}
                value={shift}
                onChange={(option) => selectShift(option)}
                maxMenuHeight={200}
              />
            </span>
          </Box>
          <Divider className={styles.partitionLine} />
          <Box bgcolor="#dadada3d" paddingTop="17px">
            <span className={styles.titlespan}>Start Time</span>
            <span
              style={{ display: "inline", marginLeft: "8%" }}
              className={styles.formSubTitle}
            >
              <TimePicker
                data-testid={"start-time-picker"}
                name="startTime"
                format="h:mm:ss A"
                value={startTime}
                onChange={(time) => setStartTime(time)}
                InputProps={{
                  disableUnderline: true,
                  className: clsx(styles.select, styles.dateInput),
                }}
              />
            </span>
          </Box>
          <Box bgcolor="#dadada3d" paddingTop="14px" paddingBottom="14px">
            <span className={styles.titlespan}>End Time</span>
            <span
              style={{ display: "inline", marginLeft: "10%" }}
              className={styles.formSubTitle}
            >
              <TimePicker
                data-testid={"end-time-picker"}
                name="endTime"
                format="h:mm:ss A"
                value={endtime}
                onChange={(time) => setEndTime(time)}
                InputProps={{
                  disableUnderline: true,
                  className: clsx(styles.select, styles.dateInput),
                }}
              />
            </span>
          </Box>
          <Box bgcolor="#dadada3d" paddingTop="14px">
            <span className={styles.titlespan}>Active From</span>
            <span
              style={{ display: "inline", marginLeft: "22px" }}
              className={styles.formSubTitle}
            >
              <CustomDatePicker
                data-testid={"from-date-picker"}
                name="activeFromDate"
                disablePast
                format="yyyy-MM-DD"
                value={activeFrom}
                onChange={(date) => setActiveFrom(date)}
                InputProps={{
                  disableUnderline: true,
                }}
              />
            </span>
          </Box>
          <Box bgcolor="#dadada3d" paddingTop="14px" paddingBottom="20px">
            <span className={styles.titlespan}>Active Until</span>
            <span
              style={{ display: "inline", marginLeft: "25px" }}
              className={styles.formSubTitle}
            >
              <CustomDatePicker
                data-testid={"to-date-picker"}
                name="activeToDate"
                format="yyyy-MM-DD"
                minDate={activeFrom}
                value={activeUntil}
                onChange={(date) => setActiveUntil(date)}
                InputProps={{
                  disableUnderline: true,
                }}
              />
            </span>
          </Box>
          <div style={{ float: "right" }}>
            <Button
              variant="primary"
              className={clsx(styles.button, styles.confirmButton)}
              type="button"
              onClick={formSubmit}
            >
              CONFIRM
            </Button>
            <Button
              className={clsx(styles.button, styles.cancelButton)}
              onClick={closeFormPopup}
            >
              CANCEL
            </Button>
          </div>
        </form>
      </Popover>
    </>
  );
};

export default ShiftMasterForm;
